import { resolveComponent as s, resolveDirective as u, openBlock as i, createBlock as n, withCtx as r, renderSlot as v, withDirectives as b, mergeProps as g, withKeys as d, withModifiers as p, resolveDynamicComponent as _ } from "vue";
import { _ as y } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
import h from "../popover/popover.js";
import w from "../button/button.js";
const D = {
  name: "EditorToolbarPopoverButton",
  components: {
    DtButton: w,
    DtPopover: h
  },
  props: {
    /**
     * Whether the button is active
     */
    isActive: {
      type: Boolean,
      default: !1
    },
    /**
     * Tooltip message
     */
    tooltipMessage: {
      type: String,
      required: !0
    },
    /**
     * Data QA attribute for testing
     */
    dataQa: {
      type: String,
      default: ""
    },
    /**
     * Popover specific data QA attribute
     */
    popoverDataQa: {
      type: String,
      default: ""
    },
    /**
     * Tab index for keyboard navigation
     */
    tabindex: {
      type: Number,
      default: -1
    },
    /**
     * Icon component
     */
    icon: {
      type: Object,
      required: !0
    }
  },
  emits: [
    /**
     * Emitted when right arrow key is pressed
     */
    "shift-focus-right",
    /**
     * Emitted when left arrow key is pressed
     */
    "shift-focus-left"
  ]
};
function q(o, e, t, x, B, k) {
  const l = s("dt-button"), c = s("dt-popover"), f = u("dt-tooltip");
  return i(), n(c, {
    "data-qa": t.popoverDataQa || `${t.dataQa}-popover`,
    padding: "small",
    "navigation-type": "arrow-keys",
    placement: "bottom-start",
    "open-with-arrow-keys": !0
  }, {
    anchor: r(({ attrs: a }) => [
      b((i(), n(l, g({ ref: "buttonRef" }, a, {
        active: t.isActive,
        "aria-label": t.tooltipMessage,
        "data-qa": t.dataQa,
        tabindex: t.tabindex,
        importance: "clear",
        kind: "muted",
        size: "xs",
        onKeydown: [
          e[0] || (e[0] = d(p((m) => o.$emit("shift-focus-right"), ["stop"]), ["right"])),
          e[1] || (e[1] = d(p((m) => o.$emit("shift-focus-left"), ["stop"]), ["left"]))
        ]
      }), {
        icon: r(() => [
          (i(), n(_(t.icon), { size: "200" }))
        ]),
        _: 1
      }, 16, ["active", "aria-label", "data-qa", "tabindex"])), [
        [f, { message: t.tooltipMessage, placement: "top" }]
      ])
    ]),
    content: r(({ close: a }) => [
      v(o.$slots, "content", { close: a })
    ]),
    _: 3
  }, 8, ["data-qa"]);
}
const C = /* @__PURE__ */ y(D, [["render", q]]);
export {
  C as default
};
//# sourceMappingURL=EditorToolbarPopoverButton.js.map
